import { render, staticRenderFns } from "./DialogOpenProject.vue?vue&type=template&id=116a9df2"
import script from "./DialogOpenProject.vue?vue&type=script&lang=js"
export * from "./DialogOpenProject.vue?vue&type=script&lang=js"
import style0 from "./DialogOpenProject.vue?vue&type=style&index=0&id=116a9df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports